import type { DiagnosisSummary, RoomID } from '@/types/app'
import type { Ref } from 'vue'
import { computed } from 'vue'
import { useKarte } from './useKarte/useKarte'
import { useMatch } from './useMatch/useMatch'
import { parseDiagnosisByUserResponseToDiagnosisSummary } from '@/apis/repositories/parsers/diagnosis.ts'
import { useDiagnosisByUserQuery } from '@/pages/ChatPage/ChatPageOwnView/hooks/useOwnChatRoom.generated.ts'

export const useMemberChatRoom = (roomId: Ref<Maybe<RoomID>>) => {
  const { match, loading: matchLoading } = useMatch(roomId, 'colleague')
  const { karte, loading: karteLoading } = useKarte(match)

  const { result: diagnosisQuery, loading: diagnosisQueryLoading } =
    useDiagnosisByUserQuery(
      computed(() => ({ userId: match.value?.user?.id?.toString() ?? '' })),
      () => ({ enabled: !!match.value?.user?.id })
    )
  const diagnosisSummary = computed<DiagnosisSummary | undefined>(() => {
    const diagnosisByUser = diagnosisQuery.value?.diagnosisByUser
    return diagnosisByUser
      ? parseDiagnosisByUserResponseToDiagnosisSummary(diagnosisByUser)
      : undefined
  })

  const loading = computed(
    () =>
      matchLoading.value || karteLoading.value || diagnosisQueryLoading.value
  )

  return {
    loading,
    match,
    karte,
    diagnosisSummary,
  }
}
